import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { FaPlay } from "react-icons/fa";
import { BLUEMONEDDBUTTONS } from "../../../constants/colors";
import SimplifiedDetails from "./components/simplifiedDetails";
import FinanceiroSupervisorLists from "../../_supervisor/financeiro/extracts";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../routes/privateRoute";

export default function Financeiro() {
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");

  return (
    <Flex
      direction={"column"}
      alignItems={"center"}
      bgColor={"#F5F5F5"}
      h="100%"
      w={"99.8%"}
    >
      <Box mb={"10px"} width={"100%"} height={"fit-content"} mx="auto" px={3}>
        <Flex
          // width={"100%"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          my={4}
          ml={5}
        >
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Flex
            // mx={4}
            // mt={4}
            color={BLUEMONEDDBUTTONS}
            fontWeight={"bold"}
            alignItems={"center"}

          >
            <Text h={"100%"} fontSize={35} mx={4}>Extratos Clientes</Text>
          </Flex>
        </Flex>
      </Box>

      <Flex w={"99.5%"} h={"95%"} overflow={"hidden"} overflowY={"scroll"}>
        {
          Number(jwtToken.role) === 3 ?
            <FinanceiroSupervisorLists />
            :
            <SimplifiedDetails />
        }
      </Flex>
    </Flex>
  );
}
